import React from 'react';
import ReactDOM from 'react-dom';
//import { hydrate, render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom'
import App from './App';
//import {unregister, registerServiceWorker} from './registerServiceWorker';
//import { initializeFirebase } from './push-notification';

//hashType="noslash"
/*const rootElement = document.getElementById('root');
if (rootElement.hasChildNodes()) {
  hydrate(<BrowserRouter><App /></BrowserRouter>, rootElement);
} else {
  render(<BrowserRouter><App /></BrowserRouter>, rootElement);
}*/

ReactDOM.render((
  <BrowserRouter>
    <App />
  </BrowserRouter>
), document.getElementById('root'))
//ReactDOM.render(<App />, document.getElementById('root'));
//unregister();
//registerServiceWorker();//DESCOMENTAR SI SE USA HTTPS
//initializeFirebase();



// WEBPACK FOOTER //
// ./src/index.js